import { useCallback } from 'react'

import { EmberRoute } from '../../../enums/emberRoute'
import { useEmberRouteToUrlGenerator } from '../../../hooks/routing/useEmberRouteToUrlGenerator'
import { useEmberTransitionTo } from '../../../hooks/routing/useEmberTransitionTo'

export const useRedirectToCsvImport = () => {
  const { transitionTo } = useEmberTransitionTo()
  const { generateUrl } = useEmberRouteToUrlGenerator()

  const redirectToCsvImport = useCallback(
    (accountId: string) => {
      if (generateUrl) {
        const url = generateUrl(EmberRoute.BankImport, accountId)
        transitionTo(url)
      }
    },
    [generateUrl, transitionTo],
  )

  return { redirectToCsvImport }
}
